/**
 * Ajuda dos campos da tabela de taxas.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/taxas': {
    'Valor minimo (R$)': 'Menor valor garantido coberto pela faixa.',
    'Valor maximo (R$)':
      'Maior valor garantido coberto pela faixa, maior que o minimo. Vazio significa sem teto de valor.',
    'Piso da taxa (%)':
      'Menor taxa aceita na faixa. Descontos nao levam a taxa sugerida abaixo do piso.',
    'Teto da taxa (%)':
      'Maior taxa aceita na faixa. Agravos nao levam a taxa sugerida acima do teto.',
    'Taxa base (%)':
      'Ponto de partida da taxa sugerida: base mais agravos menos descontos, limitada ao piso e ao teto. Precisa ficar entre o piso e o teto.',
    'Vigente a partir de':
      'Data em que a faixa passa a valer. A faixa nova nao apaga a antiga; entre as que cobrem o valor, vale a de vigencia mais recente, e faixa com vigencia futura ainda nao vale.',
  },
};
